import * as tslib_1 from "tslib";
import React from 'react';
import { compose } from 'redux';
import get from 'lodash.get';
import ElementQueries from '../../../ElementQueries';
import withCurrentGallection from '../../_hocs/withCurrentGallection';
import withFileUpload from '../../_hocs/withFileUpload';
import { MediaSourceType } from '../../types';
import UploadThumb from '../../_partials/UploadThumb';
import s from './DeviationGrid.scss';
var enhance = compose(withFileUpload, withCurrentGallection);
var DeviationGrid = /** @class */ (function (_super) {
    tslib_1.__extends(DeviationGrid, _super);
    function DeviationGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDeviation = function (deviation, index) {
            var props = _this.props;
            return (React.createElement("div", { key: index, className: s['grid-item'] }, props.deviationRenderer(deviation, index, props.deviations)));
        };
        _this.renderFileUpload = function (fileUpload) {
            var currentGallection = _this.props.currentGallection;
            var file = fileUpload.file, fileId = fileUpload.fileId, folderId = fileUpload.folderId, progress = fileUpload.progress, error = fileUpload.error;
            if (!file ||
                !currentGallection ||
                currentGallection.folderId !== folderId ||
                currentGallection.type !== MediaSourceType.STASH) {
                return null;
            }
            return (React.createElement(UploadThumb, { key: fileId, className: s['grid-item'], file: file, progress: progress, error: error }));
        };
        return _this;
    }
    DeviationGrid.prototype.shouldComponentUpdate = function (nextProps) {
        var _this = this;
        // We need to update the component if either the deviation or fileUploads
        // array has changed.
        if (nextProps.deviations.length !== this.props.deviations.length ||
            nextProps.fileUploads.length !== this.props.fileUploads.length) {
            return true;
        }
        // If the deviations array has different deviationIds
        var deviationsDidUpdate = !!nextProps.deviations.find(function (deviation, index) {
            return deviation.deviationId !==
                get(_this, "props.deviations[" + index + "].deviationId");
        });
        // ...or if the files that are currently uploading have different fileIds
        // or different progress, we need to  re-render the file upload thumb
        var fileUploadsDidUpdate = !!nextProps.fileUploads.find(function (fileUpload, index) {
            return fileUpload.fileId !== get(_this, "props.fileUploads[" + index + "].fileId") ||
                fileUpload.progress !==
                    get(_this, "props.fileUploads[" + index + "].progress");
        });
        return deviationsDidUpdate || fileUploadsDidUpdate;
    };
    DeviationGrid.prototype.render = function () {
        return (React.createElement(ElementQueries, { widthBreakpoints: [1100, 800, 700, 450], className: s['grid'] },
            this.props.fileUploads
                .sort(function (a, b) { return a.fileId - b.fileId; })
                .map(this.renderFileUpload),
            this.props.deviations.map(this.renderDeviation)));
    };
    return DeviationGrid;
}(React.Component));
export { DeviationGrid };
export default enhance(DeviationGrid);
//# sourceMappingURL=DeviationGrid.js.map